import React from 'react'

const EtDeleteUser = () => {
  return (
    <div>EtDeleteUser</div>
  )
}

export default EtDeleteUser